import React, { PureComponent } from 'react';
// redux
import { connect } from 'react-redux';
import { compose } from 'redux';
import { getModule, getLectureCondition } from '../../redux/reducers/module';
import { submitStep, updateStep } from '../../redux/reducers/completedSteps';
import { getModuleCompletedSteps } from '../../redux/reducers/completedSteps';
// hoc
import withSizes from 'react-sizes';
// components
import { toastResponseErrors } from '../../utils/response';
import PageWrapper from '../../components/PageWrapper/PageWrapper';
import ModuleProgress from './components/ModuleProgress';
import ModuleDescription from '../../components/ModuleDescription/ModuleDescription';
import NavButton from './components/NavButton';
import VideoStep from './components/VideoStep';
import QuizStep from './components/QuizStep';
import SlideshowStep from './components/SlideshowStep';
import InputStep from './components/InputStep';
import LectureStep from './components/LectureStep';
import SummaryStep from './components/SummaryStep';
import Preloader from '../../components/Preloader/Preloader';
// utils
import get from 'lodash.get';
// styles
import styles from './Module.mod.css';
import classnames from 'classnames/bind';

const cn = classnames.bind(styles);

class Module extends PureComponent {
  state = {
    activeStep: null,
  };

  componentDidMount() {
    const {
      getModule,
      match: { params },
      location,
    } = this.props;
    const step = get(location, 'state.step', null);
    const { isCompleted } = this.state;

    const id = params.id;
    getModule({ id })
      .then(() => {
        if (step !== null || isCompleted) {
          this.setActiveStep(step);
        } else {
          // this.setActiveStep(step || 4);
        }
      })
      .catch(toastResponseErrors);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      progress,
      resource,
      match: {
        params: { id },
      },
    } = nextProps;

    const step =
      id === 'relapsemodule' ? progress.relapsemodule : progress.step;
    const isCompleted =
      progress.module > id ||
      step === 0 ||
      (resource && resource.steps.length < step);

    const currentStep = Math.max(isCompleted && resource ? 0 : step - 1, 0);
    if (prevState.currentStep !== currentStep) {
      return {
        isCompleted,
        currentStep,
        activeStep: currentStep,
      };
    }
    return null;
  }

  nextStep = id => {
    const {
      submitStep,
      history,
      resource: { steps },
    } = this.props;
    const { activeStep, currentStep, isCompleted } = this.state;

    if (activeStep === currentStep && !isCompleted) {
      submitStep({
        step_id: id,
      })
        .then(() => window.scrollTo(0, 0))
        .catch(toastResponseErrors);
    } else {
      if (activeStep === steps.length - 1) {
        history.push('/dashboard');
      } else {
        this.setActiveStep(activeStep + 1);
      }
    }
  };

  goPrevStep = () => {
    const { activeStep } = this.state;
    this.setActiveStep(activeStep - 1);
  };

  getCompletedStep = index => {
    const {
      completedSteps,
      resource: { steps },
    } = this.props;
    const activeStepId = get(steps, `${index}.id`, null);

    return activeStepId && completedSteps
      ? completedSteps.find(step => step.step.id === activeStepId)
      : null;
  };

  setActiveStep = index => {
    const { resource, getModuleCompletedSteps } = this.props;
    const { currentStep, isCompleted } = this.state;

    this.setState({
      activeStep: Math.max(index, 0),
    });

    const hasCompletedStep =
      (currentStep <= index && !isCompleted) || this.getCompletedStep(index);

    if (!hasCompletedStep && resource) {
      const id = resource.id;
      getModuleCompletedSteps(id);
    }

    window.scrollTo(0, 0);
  };

  render() {
    const { activeStep, currentStep, isCompleted } = this.state;

    const {
      resource,
      isLoading,
      submitStep,
      updateStep,
      getLectureCondition,
      isCompletedLoading,
      isStepSubmitting,
      history,
      isTablet,
      isStepLoading,
    } = this.props;

    if (!resource) {
      return <Preloader className={cn('preloader')} isActive />;
    }

    const { title, steps } = resource;
    const data = steps[activeStep];
    const type = data && data.step_type;
    const menuTitle = `${title} - ${
      isCompleted
        ? 'All tasks are done'
        : `Done ${currentStep} of ${steps.length}`
    }`;

    const moduleProgressProps = {
      steps,
      title,
      currentStep,
      activeStep,
      isCompleted,
      isTablet,
      setActiveStep: this.setActiveStep,
    };

    const completedData = this.getCompletedStep(activeStep);

    const inputStepProps = {
      data,
      activeStep,
      currentStep,
      completedData,
      getLectureCondition,
      isCompleted,
      stepsLength: steps.length,
      submitStep,
      updateStep,
      history,
      setActiveStep: this.setActiveStep,
      goPrevStep: this.goPrevStep,
      key: data && data.id,
    };

    const isPreloaderActive =
      isLoading || isCompletedLoading || isStepSubmitting;
    const isNavDisabled = isStepSubmitting || isStepLoading;

    return (
      <PageWrapper>
        <div className={cn('wrapper', 'row')}>
          <Preloader className={cn('preloader')} isActive={isPreloaderActive} />
          <div className="col-sm-3">
            <h3 className={styles.progressTitle}>{menuTitle}</h3>
            <ModuleProgress {...moduleProgressProps} />
          </div>
          <div className={cn('task-wrapper', 'col-sm-9')}>
            <div className={cn('task-container')}>
              <ModuleDescription module={resource} />
              {type === 'video' && <VideoStep data={data} />}
              {type === 'lecture' && (
                <LectureStep
                  data={data}
                  key={data.id}
                  getLectureCondition={getLectureCondition}
                />
              )}
              {type === 'quiz' && <QuizStep {...inputStepProps} />}
              {type === 'summary_value' && <SummaryStep {...inputStepProps} />}
              {type === 'input' && <InputStep {...inputStepProps} />}
              {type === 'slideshow' && <SlideshowStep data={data} />}
              {['slideshow', 'summary_value', 'lecture', 'video'].includes(
                type
              ) && (
                <div className={styles.navButtons}>
                  <NavButton
                    direction="next"
                    disabled={isNavDisabled}
                    onClick={() => this.nextStep(data.id)}
                  >
                    Next
                  </NavButton>
                  {!!activeStep && (
                    <NavButton
                      direction="prev"
                      disabled={isNavDisabled}
                      onClick={this.goPrevStep}
                    >
                      Prev
                    </NavButton>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </PageWrapper>
    );
  }
}

const enhance = compose(
  connect(
    state => ({
      resource: state.module.resource,
      isLoading: state.module.isLoading,
      progress: state.auth.user.progress,
      completedSteps: state.completedSteps.completedSteps,
      isCompletedLoading: state.completedSteps.isLoading,
      isStepSubmitting: state.completedSteps.isStepSubmitting,
      isStepLoading: state.module.isLoading,
    }),
    {
      getModule,
      getLectureCondition,
      submitStep,
      updateStep,
      getModuleCompletedSteps,
    }
  ),
  withSizes(({ width }) => ({
    isMobile: width <= 480,
    isTablet: width <= 767,
  }))
);

export default enhance(Module);



// WEBPACK FOOTER //
// ./src/containers/Module/Module.jsx